export const FETCH_LOCKER_TASKS = 'APPOINTMENT_TASK/FETCH_LOCKER_TASKS';
export const FETCH_LOCKER_TASKS_SUCCESS = 'APPOINTMENT_TASK/FETCH_TASKS_SUCCESS';
export const FETCH_LOCKER_TASKS_FAILURE = 'APPOINTMENT_TASK/FETCH_TASKS_FAILURE';

export const POST_VERIFY = 'APPOINTMENT_TASK/POST_VERIFY';
export const POST_VERIFY_SUCCESS = 'APPOINTMENT_TASK/POST_VERIFY_SUCCESS';
export const POST_VERIFY_FAILURE = 'APPOINTMENT_TASK/POST_VERIFY_FAILURE';

export const POST_PREPARE = 'APPOINTMENT_TASK/POST_PREPARE';
export const POST_PREPARE_SUCCESS = 'APPOINTMENT_TASK/POST_PREPARE_SUCCESS';
export const POST_PREPARE_FAILURE = 'APPOINTMENT_TASK/POST_PREPARE_FAILURE';

export const POST_UNPREPARE = 'APPOINTMENT_TASK/POST_UNPREPARE';
export const POST_UNPREPARE_SUCCESS = 'APPOINTMENT_TASK/POST_UNPREPARE_SUCCESS';
export const POST_UNPREPARE_FAILURE = 'APPOINTMENT_TASK/POST_UNPREPARE_FAILURE';

export const DELETE_MEDIA = 'APPOINTMENT_TASK/DELETE_MEDIA';
export const DELETE_MEDIA_SUCCESS = 'APPOINTMENT_TASK/DELETE_MEDIA_SUCCESS';
export const DELETE_MEDIA_FAILURE = 'APPOINTMENT_TASK/DELETE_MEDIA_FAILURE';

export const POST_REQUEST = 'APPOINTMENT_TASK/POST_REQUEST';
export const POST_SUCCESS = 'APPOINTMENT_TASK/POST_SUCCESS';
export const POST_FAILURE = 'APPOINTMENT_TASK/POST_FAILURE';

export const POST_BILLING_TASK_REQUEST = 'APPOINTMENT_TASK/BILLING/POST_REQUEST';
export const POST_RESOLVE_ISSUE_REQUEST = 'APPOINTMENT_TASK/RESOLVE_ISSUE_REQUEST';
export const POST_RESOLVE_ISSUE_SUCCESS = 'APPOINTMENT_TASK/RESOLVE_ISSUE_SUCCESS';
export const POST_RESOLVE_ISSUE_FAILURE = 'APPOINTMENT_TASK/RESOLVE_ISSUE_FAILURE';

export const POST_KEY_DEPOSIT_REQUEST = 'APPOINTMENT_TASK/KEY_DEPOSIT/POST_REQUEST';
export const POST_KEY_RETRIEVE_REQUEST = 'APPOINTMENT_TASK/KEY_RETRIEVE/POST_REQUEST';
export const POST_CLIENT_DOCUMENT_REQUEST = 'APPOINTMENT_TASK/CLIENT_DOCUMENT/POST_REQUEST';
export const POST_REPAIR_ORDER_REQUEST = 'APPOINTMENT_TASK/REPAIR_ORDER/POST_REQUEST';
export const POST_RENTAL_VEHICLE_TASK_REQUEST = 'APPOINTMENT_TASK/RENTAL_VEHICLE/POST_REQUEST';

export const FETCH_REQUEST = 'APPOINTMENT_TASK/FETCH_REQUEST';
export const FETCH_SUCCESS = 'APPOINTMENT_TASK/FETCH_SUCCESS';
export const FETCH_FAILURE = 'APPOINTMENT_TASK/FETCH_FAILURE';

export const RESCHEDULE_REQUEST = 'APPOINTMENT_TASK/RESCHEDULE/POST_REQUEST';
export const RESCHEDULE_SUCCESS = 'APPOINTMENT_TASK/RESCHEDULE/POST_SUCCESS';
export const RESCHEDULE_FAILURE = 'APPOINTMENT_TASK/RESCHEDULE/POST_FAILURE';

export const RESCHEDULE_KEY_DEPOSIT_REQUEST = 'APPOINTMENT_TASK/KEY_DEPOSIT/RESCHEDULE/POST_REQUEST';
export const RESCHEDULE_KEY_RETRIEVE_REQUEST = 'APPOINTMENT_TASK/KEY_RETRIEVE/RESCHEDULE/POST_REQUEST';

export const PUT_REQUEST = 'APPOINTMENT_TASK/PUT_REQUEST';
export const PUT_SUCCESS = 'APPOINTMENT_TASK/PUT_SUCCESS';
export const PUT_FAILURE = 'APPOINTMENT_TASK/PUT_FAILURE';

export const PUT_KEY_DEPOSIT_REQUEST = 'APPOINTMENT_TASK/KEY_DEPOSIT/PUT_REQUEST';
export const PUT_KEY_RETRIEVE_REQUEST = 'APPOINTMENT_TASK/KEY_RETRIEVE/PUT_REQUEST';

export const DELETE_REQUEST = 'APPOINTMENT_TASK/DELETE_REQUEST';
export const DELETE_SUCCESS = 'APPOINTMENT_TASK/DELETE_SUCCESS';
export const DELETE_FAILURE = 'APPOINTMENT_TASK/DELETE_FAILURE';

export const DELETE_BILLING_REQUEST = 'APPOINTMENT_TASK/BILLING/DELETE_REQUEST';
export const DELETE_REPAIR_ORDER_REQUEST = 'APPOINTMENT_TASK/REPAIR_ORDER/DELETE_REQUEST';
export const DELETE_KEY_DEPOSIT_REQUEST = 'APPOINTMENT_TASK/KEY_DEPOSIT/DELETE_REQUEST';
export const DELETE_KEY_RETRIEVE_REQUEST = 'APPOINTMENT_TASK/KEY_RETRIEVE/DELETE_REQUEST';
export const DELETE_CLIENT_DOCUMENT_REQUEST = 'APPOINTMENT_TASK/CLIENT_DOCUMENT/DELETE_REQUEST';
export const DELETE_RENTAL_VEHICLE_TASK_REQUEST = 'APPOINTMENT_TASK/RENTAL_VEHICLE/DELETE_REQUEST';

export const ACKNOWLEDGE_ISSUE = 'APPOINTMENT_TASK/ACKNOWLEDGE_ISSUE';
export const ACKNOWLEDGE_ISSUE_SUCCESS = 'APPOINTMENT_TASK/ACKNOWLEDGE_ISSUE_SUCCESS';

export const SHOW_ADD_DRIVER_LICENCE = 'APPOINTMENT_TASK/SHOW_ADD_DRIVER_LICENCE';
export const HIDE_ADD_DRIVER_LICENCE = 'APPOINTMENT_TASK/HIDE_ADD_DRIVER_LICENCE';
export const ADD_DRIVER_LICENCE = 'APPOINTMENT_TASK/ADD_DRIVER_LICENCE';
